<template>
  <b-card
    id="tooltip-edge"
    style="
      width: 550px;
      opacity: 0;
      position: absolute;
      left: 150px;
      top: 150px;
      z-index: -1;
    "
    class="mb-2 shadow bg-white"
  >
    <b-card-title>
      <b-button id="tooltip-edge-button-close" class="close">
        <span class="d-inline-block">&times;</span>
      </b-button>
      <h4>
        {{ edge.source.name }}
        <span
          class="badge badge-secondary"
          :style="{
            'background-color': entityColorScale(edge.source.group),
          }"
        >
          {{ edge.source.group }}
        </span>
        -
        {{ edge.target.name }}
        <span
          class="badge badge-secondary"
          :style="{
            'background-color': entityColorScale(edge.target.group),
          }"
        >
          {{ edge.target.group }}
        </span>
      </h4>
    </b-card-title>
    <b-card-text>
      Cooccurrences: {{ edge.n }}; Weight:
      {{ Math.round(edge.value * 100) / 100 }}
      <hr />
      <b-overlay
        :show="status.showSpinner"
        rounded="sm"
        style="overflow-y: auto; min-height: 250px; max-height: 400px"
      >
        <b-tabs content-class="mt-3">
          <b-tab
            v-for="(context, id) in contexts"
            :key="id"
            :title="'Context ' + (id + 1)"
          >
            <b-card
              v-for="(sentence, id) in context"
              :key="id"
              title=""
              class="m-2"
            >
              <b-card-text>
                <span v-for="(token, id) in sentence" :key="id">
                  <span
                    v-if="
                      (token.entity_type === edge.source.group &&
                        token.text.toLowerCase() ===
                          edge.source.name.toLowerCase()) ||
                      (token.entity_type === edge.target.group &&
                        token.text.toLowerCase() ===
                          edge.target.name.toLowerCase())
                    "
                  >
                    <mark>{{ token.text }}</mark>
                    <span> </span>
                  </span>
                  <span v-else class="text-muted">{{ token.text }} </span>
                </span>
              </b-card-text>
            </b-card>
          </b-tab>
        </b-tabs>
      </b-overlay>
    </b-card-text>
  </b-card>
</template>

<script>
import requestsMixin from "../mixins/requestsMixin";
import constantsMixin from "../mixins/constantsMixin";

export default {
  name: "component-tooltip-edge",
  mixins: [requestsMixin, constantsMixin],
  props: { corpus_id: { type: String }, edge: { type: Object } },
  data() {
    return {
      status: {
        showSpinner: true,
      },
      contexts: [],
    };
  },
  watch: {
    edge(value) {
      this.fetchEdgeDetails();
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/exploreGraphTooltipEdge.vue